export enum AgeBracket {
	Child		= 0,
	Teenager	= 1,
	Adult		= 2,
	None		= 3
}